import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import hero from "./hero.png";
import "./riskAnalyzerlanding.scss";
import RiskAnalyzerlandingsignUp from "./riskAnalyzerlandingsignUp";
import Loader from "../../layout/lodaer";
// hero

const RiskAnalyzerlanding = () => {
  const [loading, setLoading] = useState(true);
  const [initialLoad, setInitialLoad] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const handleGoBack = () => {
    setShowModal(false);
  };
  const fetchStarted = () => {
    setShowModal(true);
  };

  useEffect(() => {
    if (initialLoad) {
      setTimeout(() => {
        setLoading(false);
        setInitialLoad(false);
      }, 2000); // 2 seconds delay, adjust as needed
    }
  }, [initialLoad]);
  return (

    <>
    {loading ? (
      <Loader />
    ) : (
      <div>
        <div className="main">
          <div className="banner">
            <div className="empty_data">
              <img src={hero} alt="Data not found" className="empty_img" />
              <h6 className="title">
                <i className="fa fa-dashboard me-2" />
                Risk Analyser
              </h6>
            </div>
          </div>
          <div className="content">
            <div className="container">
              <div className="content_style">
                <h4 className="head_style">Access your Appetite for Risk</h4>
                <p className="paragraph_style">
                  We will take you through a simple risk profile questionnaire.
                  Please provide the most suitable responses
                </p>
              </div>
              <div className="middle_content">
                <div className="underline" />
                <p className="para_style">
                  Risk profiling is{" "}
                  <strong>
                    an evaluation of an individual's willingness and ability to
                    take risks{" "}
                  </strong>
                  and it is considered as a very critical step for determining a
                  proper asset allocation for an investment portfolio
                </p>
                <h4 className="risk_title">Why Risk Profile?</h4>
                <ul className="list_style">
                  <li>
                    Helps understand the level of risk you are comfortable with{" "}
                  </li>
                  <li>Helps align your finances with your risk appetite</li>
                </ul>
                <div className="btnn">
                  <button className="btnstart" onClick={() => fetchStarted()}>
                    Get Started
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={showModal} onHide={handleGoBack}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <RiskAnalyzerlandingsignUp />
          </Modal.Body>
          {/* <Modal.Footer>
            <Button className="back" onClick={handleGoBack}>
              Go Back
            </Button>
          </Modal.Footer> */}
        </Modal>
      </div>
    )}
  </>
  );
};

export default RiskAnalyzerlanding;
